var path = 'app/components/common/forms/templates/fieldset.html';
var html = "<fieldset class=\"{{to.className}}\"><legend><span>{{to.label}}</span></legend><formly-transclude></formly-transclude></fieldset>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/forms/templates/fieldset.html
// module id = 188
// module chunks = 0